import { render, staticRenderFns } from "./ClientReportPrescribedParamForm.vue?vue&type=template&id=37694479&scoped=true"
import script from "./ClientReportPrescribedParamForm.vue?vue&type=script&lang=js"
export * from "./ClientReportPrescribedParamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37694479",
  null
  
)

export default component.exports